<div class="table-total-loops">
  <div class="loops rounded" *ngFor="let marineLoop of marineLoops">
    <p class="title-loops text-left">{{ 'totalloopbyshift' | lang | uppercase}} {{ marineLoop.shiftName }}</p>
    <p class="subtitle-loops text-right">{{ marineLoop.totalLoopByShift}}</p>
  </div>
</div>